<template>
  <div class="shaking-flashlight-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>Φ 变化 → E = -n(dΦ/dt)$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Flashlight Body -->
          <rect x="100" y="80" width="200" height="80" rx="10" fill="#333" stroke="#666" />
          
          <!-- The Coil -->
          <g transform="translate(150, 100)">
             <path v-for="i in 8" :key="i" :d="`M ${i*12},0 Q ${i*12 + 6}, -20 ${i*12 + 12}, 0`" fill="none" stroke="#ffd700" stroke-width="2" />
             <path v-for="i in 8" :key="'b'+i" :d="`M ${i*12},0 Q ${i*12 + 6}, 20 ${i*12 + 12}, 0`" fill="none" stroke="#5a4500" stroke-width="2" stroke-dasharray="2" />
          </g>

          <!-- The Sliding Magnet -->
          <g :transform="`translate(${140 + magnetPos}, 110)`">
             <rect x="0" y="0" width="40" height="20" fill="#ff4757" />
             <rect x="40" y="0" width="40" height="20" fill="#00d2ff" />
             <text x="10" y="15" fill="#fff" font-size="10">N</text>
             <text x="60" y="15" fill="#fff" font-size="10">S</text>
          </g>

          <!-- LED Light -->
          <circle cx="280" cy="120" :r="charge/10" :fill="charge > 10 ? '#fff700' : '#444'" :opacity="charge/100">
             <animate attributeName="opacity" values="0.2;1;0.2" dur="0.1s" repeatCount="indefinite" v-if="charge > 50" />
          </circle>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>电量 Storage: {{ charge.toFixed(0) }}%</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row">
             <el-button type="warning" size="mini" @click="shake">模拟快速摇晃 (Shake!)</el-button>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>摇晃手电筒无需电池也能发光。其内部有一个可以自由滑动的强磁铁，穿过一组固定的线圈。当手电筒动摇时，磁铁穿过线圈，导致通过线圈的**磁通量**发生剧烈变化，从而产生**感应电流**。电流通过整流桥后储存在超级电容器中，足以点亮 LED 燈数分钟。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ElectromagneticChargingViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      magnetPos: 0,
      charge: 0,
      targetPos: 80,
      speed: 0
    }
  },
  methods: {
    shake() {
       this.speed = 20;
       // Charge increases with flux change
       this.charge = Math.min(100, this.charge + 10);
    },
    update() {
       // Oscillating motion simulation
       this.magnetPos += (this.targetPos - this.magnetPos) * 0.1;
       if (Math.abs(this.targetPos - this.magnetPos) < 1) {
          this.targetPos = this.targetPos === 80 ? 0 : 80;
       }
       // Slow decay
       if (this.charge > 0) this.charge *= 0.9995;
       
       requestAnimationFrame(this.update);
    }
  },
  mounted() { this.update(); },
  beforeDestroy() {
    if (this.animFrame) cancelAnimationFrame(this.animFrame);
    if (this.timer) clearInterval(this.timer);
  },
}
</script>

<style scoped lang="scss">
.shaking-flashlight-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(255, 215, 0, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
